import { City } from './city';
import { Country } from './country';
import { CustomerEmail } from './customer-email';
import { RecievedDate } from './recieved-date';
import { ReturnNote } from './return-note';
import { ReturningParty } from './returning-party';
import { RmaNumber } from './rma-number';
import { ShipTo } from './ship-to';
import { State } from './state';
import { OrderNumber } from './order-number';
import { CreatedDate } from './created-date';
import { Service } from './service';
import { InsuranceFee } from './insurance-fee';
import { Provider } from './provider';
import { PackageColumn } from './package-column';
import { Insurance } from './insurance';
import { Confirmation } from './confirmation';
import { Rate } from './rate';
import { Carrier } from './carrier';
import { LabelPrinted } from './label-printed';
import { TrackingNumber } from './tracking-number';

export const uniqueReturnsGridColumns = [
  City,
  Country,
  CustomerEmail,
  RecievedDate,
  ReturnNote,
  ReturningParty,
  RmaNumber,
  ShipTo,
  State,
  OrderNumber,
  CreatedDate,
  Service,
  InsuranceFee,
  Provider,
  PackageColumn,
  Insurance,
  Confirmation,
  Rate,
  Carrier,
  LabelPrinted,
  TrackingNumber,
];
